module.exports = __webpack_public_path__ + "img/img_mob.a979c69a.png";